<template>
    <div>
        <el-tree
         :props="props"
         :load="loadNode"
         lazy
         highlight-current
         accordion
         :expand-on-click-node='false'
         show-checkbox
         @check='getCheckedNodes'
         v-loading='loading'>
            <span class="custom-tree-node" slot-scope="{ node, data }">
                <span>{{ node.data.title }}</span>
            </span>
        </el-tree>
    </div>
</template>

<script>
import { serviceList } from './service.services'
export default {
    data() {
        return {
            props: {
                label: 'name',
                children: 'zones',
                isLeaf: 'hasChildren'
            },
            checkedNodes: [],
            loading: true
        };
    },
    methods: {
        loadNode(node, resolve) { // 请求数据查找子项
            if (node.level === 0) {
                serviceList().then(res => {
                    let newArr = res.list.map(item =>  {return {...item, hasChildren: !item.hasChildren}})
                     this.loading = false
                    resolve(newArr)
                })
                return 
            }
            setTimeout(() => {
                serviceList({parentNumber: node.data.serialNumber}).then(res => {
                    let newArr = res.list.map(item =>  {return {...item, hasChildren: !item.hasChildren}})
                    this.loading = false
                    resolve(newArr)
                })
            }, 500);
        },
        request(params) { // 获取列表数据
            cmdbLlist(params).then(res => {
                this.tableData = res.list;
                this.loading = false
            }).catch(err => {
                this.$message.error(err.message);
            }).finally(() => {
                this.loading = false;
            })
        },
        getCheckedNodes(node, data) {
            this.$emit('getServes', data.checkedNodes)
        }
    }

}
</script>

<style>

</style>
